import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TestimonialBox } from '../components/TestimonialBox';
import { ProductSidebar } from '../components/ProductSidebar';
import { CTASection } from '../components/CTASection';
import { StickyBottomBar } from '../components/StickyBottomBar';
export function AdvertorialPage() {
  const testimonials = [{
    author: 'Jennifer K., 41',
    location: 'Denver, CO',
    quote: "I promised myself I wouldn't drink for 47 nights straight. I broke it 47 times. After two weeks on the patch, I finally kept the promise. I'm three months in now and I still can't believe it worked."
  }, {
    author: 'Michael R., 38',
    location: 'Seattle, WA',
    quote: 'I was too scared to admit it was a problem because my life looked fine. But I knew. The patch let me address it before it got worse. Best decision I ever made.'
  }, {
    author: 'Lisa M., 44',
    location: 'Portland, OR',
    quote: "Wine used to relax me. Then it stopped. I kept drinking anyway because I didn't know what else to do. The patch gave me actual calm back. Not fake calm. Real calm."
  }, {
    author: 'Sarah T., 46',
    location: 'Austin, TX',
    quote: 'After 12 years of nightly wine, I stopped wanting it in week one. My nervous system finally had what it needed.'
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-127">
      <Header data-id="element-128" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-129">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-130">
          {/* Main Content Column */}
          <article className="w-full lg:w-[65%]" data-id="element-131">
            <Hero data-id="element-132" />

            {/* IMAGE 1: Doctor in office */}
            <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-133">
              <img src="https://cdn.magicpatterns.com/uploads/hpZoyrKXNKJ1EcCdKC7wkN/ChatGPT_Image_10_Ιαν_2026,_11_55_32_π.μ..png" alt="Doctor in office looking at brain scan, patient consultation setting" className="w-full h-auto rounded-lg" data-id="element-134" />
            </div>

            <div className="prose prose-lg max-w-none text-gray-800 font-serif leading-relaxed" data-id="element-135">
              <p className="text-xl mb-6 font-semibold text-gray-900" data-id="element-136">
                I'm Dr. Sarah Mitchell, and I need to tell you something most
                doctors won't say out loud.
              </p>

              <p className="mb-6" data-id="element-137">
                For 15 years, I've treated adults who drink wine or beer every
                night. Not alcoholics. Not people who've lost everything. Just
                normal, successful people who can't seem to stop.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-138">
                And here's what I've learned: It's not about willpower. It never
                was.
              </p>

              <p className="mb-6" data-id="element-139">
                I've seen patients who run companies. Patients who are doctors
                themselves. Patients who've accomplished incredible things in
                their lives.
              </p>

              <p className="mb-6" data-id="element-140">
                But when 7 PM rolls around, something happens. And the wine
                comes out. Again.
              </p>

              <p className="mb-6" data-id="element-141">
                They promise themselves every morning: "Not tonight."
              </p>

              <p className="mb-6" data-id="element-142">By evening, that promise is broken.</p>

              <p className="mb-8" data-id="element-143">And they have no idea why.</p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-144">
                The Three Patients Who Changed Everything
              </h2>

              <p className="mb-6" data-id="element-145">
                Let me tell you about three people I treated in the same week.
                Three completely different stories. But the same problem
                underneath.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-146">
                Patient One: The Broken Promise
              </h3>

              <p className="mb-6" data-id="element-147">
                Jennifer came to my office after her annual physical showed
                elevated liver enzymes.
              </p>

              <p className="mb-6 text-lg italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-148">
                "I don't understand," she said. "I promise myself every single
                morning that I won't drink. And by 7 PM, I've broken that
                promise. Again."
              </p>

              <p className="mb-6" data-id="element-149">
                She'd been doing this for four years. Same cycle. Same broken
                promise. Every single day.
              </p>

              <p className="mb-6 italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-150">
                "I feel like I can't trust myself anymore," she told me. "If I
                can't keep a simple promise to myself, what does that say about
                who I am?"
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-151">
                Patient Two: The Functional One
              </h3>

              <p className="mb-6" data-id="element-152">
                Michael sat across from me looking perfectly fine. Good job.
                Healthy weight. Exercised regularly.
              </p>

              <p className="mb-6" data-id="element-153">"So why are you here?" I asked.</p>

              <p className="mb-6 italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-154">
                "I Googled something last night," he said quietly. "I typed in
                'is three beers every night too much?' And I realized... if I'm
                asking the question, I probably already know the answer."
              </p>

              <p className="mb-6" data-id="element-155">
                He wasn't falling apart. His life wasn't collapsing. But
                something inside him knew this was a problem.
              </p>

              <p className="mb-8" data-id="element-156">
                He just needed someone to tell him it was okay to care about it.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-157">
                Patient Three: The Wine That Stopped Working
              </h3>

              <p className="mb-6" data-id="element-158">
                Lisa had been drinking two glasses of wine every night for six
                years.
              </p>

              <p className="mb-6 italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-159">
                "It used to help me relax," she said. "After a stressful day,
                wine was my reward. My wind-down."
              </p>

              <p className="mb-6" data-id="element-160">"But now?"</p>

              <p className="mb-6 italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-161">
                "Now it makes me more stressed. I finish the second glass and
                I'm not relaxed. I'm anxious. My mind is racing. I don't even
                enjoy it anymore."
              </p>

              <p className="mb-6" data-id="element-162">She paused.</p>

              <p className="mb-8 italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-163">
                "So why do I keep drinking it?"
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-164">
                What I Discovered
              </h2>

              <p className="mb-6" data-id="element-165">
                These three patients—Jennifer, Michael, and Lisa—seemed like
                they had completely different problems.
              </p>

              <p className="mb-4" data-id="element-166">One couldn't keep promises to herself.</p>
              <p className="mb-4" data-id="element-167">One was functional but questioning.</p>
              <p className="mb-6" data-id="element-168">One's wine had stopped working.</p>

              <p className="mb-6" data-id="element-169">
                But after years of treating patients like them, I realized
                something:
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-170">
                They all had the same root cause.
              </p>

              <p className="mb-6" data-id="element-171">
                Not addiction. Not weakness. Not lack of discipline.
              </p>

              <p className="mb-6 font-bold text-gray-900 text-xl" data-id="element-172">
                Their nervous systems were broken.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-173">
                And here's the part that changed everything for me as a doctor:
                You can't fix a broken nervous system with willpower.
              </p>

              {/* IMAGE 2: Nervous system / brain scan visual */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-174">
                <img src="https://cdn.magicpatterns.com/uploads/nrKnszkQKZbSsztMMBA8WE/ChatGPT_Image_10_Ιαν_2026,_11_55_30_π.μ..png" alt="Brain scan showing stress response patterns" className="w-full h-auto rounded-lg" data-id="element-175" />
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-176">
                Here's What's Really Happening in Your Body
              </h2>

              <p className="mb-6" data-id="element-177">
                Let me explain this the way I wish someone had explained it to
                me in medical school.
              </p>

              <p className="mb-6" data-id="element-178">
                Think of your nervous system like a car with two pedals.
              </p>

              <p className="mb-4" data-id="element-179">
                The <strong data-id="element-180">gas pedal</strong> is your sympathetic nervous
                system. It's alert. Active. Stressed. Fight-or-flight.
              </p>

              <p className="mb-6" data-id="element-181">
                The <strong data-id="element-182">brake pedal</strong> is your parasympathetic nervous
                system. It's calm. Relaxed. Rest-and-digest.
              </p>

              <p className="mb-6" data-id="element-183">
                Most people's nervous systems naturally switch between the two.
                Gas pedal during work. Brake pedal in the evening.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-184">
                But here's what happens when you're stressed for years:
              </p>

              <p className="mb-6 font-bold text-gray-900 text-xl" data-id="element-185">
                Your gas pedal gets stuck down.
              </p>

              <p className="mb-6" data-id="element-186">
                Work stress. Family stress. Life stress. It all floods your body
                with a hormone called cortisol.
              </p>

              <p className="mb-6" data-id="element-187">
                Cortisol keeps your nervous system locked in emergency mode.
                Constantly alert. Constantly activated. Constantly on edge.
              </p>

              <p className="mb-6" data-id="element-188">
                By the time evening rolls around, your brain is desperate for
                relief from that constant state of alarm.
              </p>

              <p className="mb-6" data-id="element-189">
                And alcohol? Alcohol temporarily forces your nervous system to
                calm down.
              </p>

              <p className="mb-4" data-id="element-190">So your body learns: "Wine equals relief."</p>

              <p className="mb-4" data-id="element-191">It's not a habit. It's not a choice.</p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-192">
                It's a chemical dependency your stressed-out body has developed
                just to survive.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-193">
                Why Your Brake Pedal Doesn't Work Anymore
              </h2>

              <p className="mb-6" data-id="element-194">Here's the part that makes it worse:</p>

              <p className="mb-6" data-id="element-195">
                When you drink alcohol regularly, your brain stops making
                something called GABA.
              </p>

              <p className="mb-6" data-id="element-196">
                GABA is your brain's natural calming chemical. It's what lets
                you relax without needing anything external.
              </p>

              <p className="mb-6" data-id="element-197">
                But if alcohol is doing that job for you, your brain says: "Why
                make GABA? We don't need it."
              </p>

              <p className="mb-6" data-id="element-198">
                So your GABA production drops. Lower and lower. Until it's
                basically gone.
              </p>

              <p className="mb-4 font-bold text-gray-900" data-id="element-199">
                Now you have two problems:
              </p>

              <ul className="space-y-2 mb-8 list-none pl-0" data-id="element-200">
                <li className="flex items-start" data-id="element-201">
                  <span className="text-red-500 mr-2 font-bold" data-id="element-202">1.</span>
                  <span data-id="element-203">
                    Your gas pedal is stuck (cortisol flooding your system all
                    day)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-204">
                  <span className="text-red-500 mr-2 font-bold" data-id="element-205">2.</span>
                  <span data-id="element-206">
                    Your brake pedal doesn't work (no GABA to calm you down
                    naturally)
                  </span>
                </li>
              </ul>

              <p className="mb-6 font-bold text-gray-900 text-xl" data-id="element-207">
                Alcohol becomes the only emergency brake you have left.
              </p>

              <p className="mb-6" data-id="element-208">
                That's why "just one glass" feels impossible.
              </p>

              <p className="mb-8" data-id="element-209">
                Your body isn't looking for a drink. It's looking for the only
                way it knows how to turn off the alarm bells.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-210">
                Why Everything You've Tried Has Failed
              </h2>

              <p className="mb-6" data-id="element-211">This is why willpower doesn't work.</p>

              <p className="mb-6" data-id="element-212">
                When you try to quit through sheer determination, you're asking
                a flooded nervous system to calm itself using thoughts.
              </p>

              <p className="mb-8 font-bold text-gray-900 text-lg" data-id="element-213">
                That's like trying to stop a car with a stuck gas pedal by
                thinking really hard about braking.
              </p>

              <p className="mb-6" data-id="element-214">
                It doesn't matter how motivated you are. It doesn't matter how
                much you love your family.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-215">
                Your body is in a state of chemical crisis. And it will do
                whatever it takes to find relief.
              </p>

              <p className="mb-6" data-id="element-216">Let me tell you what I see patients try:</p>

              {/* IMAGE 3: Failed attempts */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-217">
                <img src="https://cdn.magicpatterns.com/uploads/sQA8uibMb87JX2BcX3hvwA/ChatGPT_Image_10_Ιαν_2026,_11_55_29_π.μ..png" alt="Flat lay of failed attempts: therapy card, sobriety app, supplement bottles, handwritten rules with items crossed out" className="w-full h-auto rounded-lg" data-id="element-218" />
              </div>

              <div className="space-y-6 mb-8" data-id="element-219">
                <div data-id="element-220">
                  <p className="font-bold text-gray-900 mb-2" data-id="element-221">
                    They make rules.
                  </p>
                  <p className="text-gray-700" data-id="element-222">
                    "Only on weekends. Only two glasses. Only after 8 PM." They
                    follow them for a few days. Then break them. The guilt from
                    breaking their own rules makes them drink more.
                  </p>
                </div>
                <div data-id="element-223">
                  <p className="font-bold text-gray-900 mb-2" data-id="element-224">
                    They download apps.
                  </p>
                  <p className="text-gray-700" data-id="element-225">
                    They track every drink. Watch the counter go up. Feel worse
                    about themselves. Eventually stop logging.
                  </p>
                </div>
                <div data-id="element-226">
                  <p className="font-bold text-gray-900 mb-2" data-id="element-227">
                    They go to therapy.
                  </p>
                  <p className="text-gray-700" data-id="element-228">
                    They talk about their childhood. Their stress. Their habits.
                    They leave feeling slightly better. Then they drink that
                    night anyway.
                  </p>
                </div>
                <div data-id="element-229">
                  <p className="font-bold text-gray-900 mb-2" data-id="element-230">
                    They switch drinks.
                  </p>
                  <p className="text-gray-700" data-id="element-231">
                    From wine to beer. Beer to hard seltzer. Thinking a
                    different drink will be easier to control. It's not.
                  </p>
                </div>
                <div data-id="element-232">
                  <p className="font-bold text-gray-900 mb-2" data-id="element-233">
                    They try to quit cold turkey.
                  </p>
                  <p className="text-gray-700" data-id="element-234">
                    And that's when things get dangerous. Because when you
                    suddenly remove alcohol from a nervous system that's been
                    depending on it, your body goes into crisis. I've had
                    patients end up in the ER. Heart racing. Hands shaking.
                    Panic attacks. One patient had a seizure. All because they
                    tried to quit with willpower alone.
                  </p>
                </div>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-235">
                The Real Reason You Keep Breaking Your Promise
              </h2>

              <p className="mb-6" data-id="element-236">
                Jennifer—the patient who couldn't keep promises to herself—asked
                me a question I'll never forget:
              </p>

              <p className="mb-6 italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-237">
                "If I can't trust myself to do this one simple thing, what does
                that say about me as a person?"
              </p>

              <p className="mb-6" data-id="element-238">I looked at her and said:</p>

              <p className="mb-6 font-bold text-gray-900 text-lg" data-id="element-239">
                "It says your nervous system is broken. Not your character."
              </p>

              <p className="mb-6" data-id="element-240">
                See, every morning, her cortisol levels were normal. Her
                willpower was strong. Her resolve was real.
              </p>

              <p className="mb-6" data-id="element-241">
                But by 7 PM, her cortisol had been building all day. Her GABA
                was still depleted. And her nervous system hit a breaking point.
              </p>

              <p className="mb-6" data-id="element-242">
                That 7 PM urge wasn't weakness. It was biology.
              </p>

              <p className="mb-8" data-id="element-243">
                Her brain was chemically demanding relief. And she had no
                natural way to provide it. So the promise broke. Not because she
                was weak. But because her nervous system was in emergency mode.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-244">
                Why You're Asking "Is This a Problem?"
              </h2>

              <p className="mb-6" data-id="element-245">
                Michael—the patient who Googled "is three beers every night too
                much?"—said something that stuck with me:
              </p>

              <p className="mb-6 italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-246">
                "I function fine. I go to work. I exercise. So how do I know if
                this actually counts as a problem?"
              </p>

              <p className="mb-6" data-id="element-247">Here's what I told him:</p>

              <p className="mb-6 font-bold text-gray-900 text-lg" data-id="element-248">
                "If you're asking the question, you already know the answer."
              </p>

              <p className="mb-6" data-id="element-249">
                Your body is smarter than you think. It's giving you signals.
              </p>

              <p className="mb-4" data-id="element-250">
                The fact that you're asking means something inside you knows
                this isn't right.
              </p>
              <p className="mb-4" data-id="element-251">
                You don't have to wait until your life falls apart to care about
                this.
              </p>
              <p className="mb-4" data-id="element-252">
                You don't have to hit rock bottom to deserve help.
              </p>
              <p className="mb-4 font-bold text-gray-900" data-id="element-253">
                Functional doesn't mean fine.
              </p>
              <p className="mb-8" data-id="element-254">
                And the fact that you're still showing up to work doesn't mean
                your nervous system isn't suffering.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-255">
                Why Wine Stopped Working
              </h2>

              <p className="mb-6" data-id="element-256">
                Lisa—the patient whose wine stopped relaxing her—was confused.
              </p>

              <p className="mb-6 italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-257">
                "It used to help," she said. "Now it makes everything worse.
                Why?"
              </p>

              <p className="mb-6" data-id="element-258">Here's what I explained:</p>

              <p className="mb-6" data-id="element-259">
                For the first year or two, alcohol genuinely forced her cortisol
                down. It felt like relief because it was.
              </p>

              <p className="mb-6" data-id="element-260">But over time, her body adapted.</p>

              <p className="mb-6" data-id="element-261">
                When you force cortisol down artificially every night, your body
                fights back. It starts overproducing cortisol to compensate.
              </p>

              <p className="mb-6" data-id="element-262">
                So now, six years later, her cortisol levels are higher than
                ever. And the wine can't keep up.
              </p>

              <p className="mb-6" data-id="element-263">
                She's drinking to calm down. But the alcohol can't override the
                massive cortisol spike anymore.
              </p>

              <p className="mb-4 font-bold text-gray-900" data-id="element-264">
                That's why wine stopped working.
              </p>

              <p className="mb-8" data-id="element-265">
                It's not that she needs more wine. It's that her nervous system
                is so flooded with stress hormones that alcohol can't fix it
                anymore.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-266">
                The Moment Everything Clicked for Me
              </h2>

              <p className="mb-6" data-id="element-267">
                I was sitting in my office one day, looking at these three
                patients' charts.
              </p>

              <p className="mb-6" data-id="element-268">Jennifer. Michael. Lisa.</p>

              <p className="mb-6" data-id="element-269">
                Three different stories. But the same blood work. The same
                cortisol levels. The same depleted GABA.
              </p>

              <p className="mb-6" data-id="element-270">And I realized:</p>

              <p className="mb-6 font-bold text-gray-900 text-xl" data-id="element-271">
                They don't need willpower. They need biochemical support.
              </p>

              <p className="mb-6" data-id="element-272">
                Their nervous systems are broken. And you can't fix a broken
                nervous system with discipline.
              </p>

              <ul className="space-y-2 mb-8 list-none pl-0" data-id="element-273">
                <li className="flex items-start" data-id="element-274">
                  <span className="text-[#1E4D3D] mr-2" data-id="element-275">→</span>
                  <span data-id="element-276">You have to give the body what it's been missing.</span>
                </li>
                <li className="flex items-start" data-id="element-277">
                  <span className="text-[#1E4D3D] mr-2" data-id="element-278">→</span>
                  <span data-id="element-279">You have to rebuild the GABA production.</span>
                </li>
                <li className="flex items-start" data-id="element-280">
                  <span className="text-[#1E4D3D] mr-2" data-id="element-281">→</span>
                  <span data-id="element-282">You have to regulate the cortisol.</span>
                </li>
                <li className="flex items-start" data-id="element-283">
                  <span className="text-[#1E4D3D] mr-2" data-id="element-284">→</span>
                  <span data-id="element-285">
                    You have to repair the brake pedal so the body can calm down
                    naturally again.
                  </span>
                </li>
              </ul>

              <p className="mb-8 font-bold text-gray-900" data-id="element-286">
                Once I understood that, everything changed.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-287">
                What I Started Recommending
              </h2>

              <p className="mb-6" data-id="element-288">
                I began researching solutions that actually addressed the root
                cause.
              </p>

              <p className="mb-6" data-id="element-289">
                Not willpower programs. Not therapy alone. Not apps.
              </p>

              <p className="mb-6" data-id="element-290">
                Something that would give the body the biochemical support it
                was screaming for.
              </p>

              <p className="mb-6" data-id="element-291">
                And I found something I hadn't seen before.
              </p>

              <p className="mb-8" data-id="element-292">
                A transdermal patch system designed specifically for people
                whose drinking is driven by nervous system dysregulation.
              </p>

              <p className="mb-8 font-bold text-gray-900 text-xl" data-id="element-293">
                It's called Glisera.
              </p>

              {/* IMAGE 4: Patch on arm */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-294">
                <img src="https://cdn.magicpatterns.com/uploads/oXi8MQgdXbLKDi3874FUbV/ChatGPT_Image_10_Ιαν_2026,_11_55_22_π.μ..png" alt="Close-up of a discreet transdermal patch on a woman's upper arm" className="w-full h-auto rounded-lg" data-id="element-295" />
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-296">
                Here's Why It's Different
              </h2>

              <p className="mb-6" data-id="element-297">
                Most solutions treat the symptoms. This targets the root cause.
              </p>

              <p className="mb-6" data-id="element-298">
                The patch delivers ingredients that actually rebuild what
                alcohol has depleted:
              </p>

              <div className="bg-gray-50 p-6 rounded-lg mb-8" data-id="element-299">
                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-300">
                  GABA Precursors
                </h3>
                <p className="mb-6" data-id="element-301">
                  These are the building blocks your brain needs to make GABA
                  naturally again. The calming chemical that alcohol replaced.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-302">
                  Magnesium Threonate
                </h3>
                <p className="mb-6" data-id="element-303">
                  The only form of magnesium that crosses the blood-brain
                  barrier. It calms the neural hyperactivity that makes you feel
                  on edge.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-304">
                  B-Vitamin Complex
                </h3>
                <p className="mb-6" data-id="element-305">
                  Alcohol rapidly depletes B-vitamins. Without them, your
                  nervous system can't produce calming neurotransmitters. The
                  patch replenishes them continuously.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-306">
                  Adaptogenic Herbs
                </h3>
                <p data-id="element-307">
                  Clinically shown to lower cortisol levels and activate your
                  parasympathetic nervous system—the brake pedal.
                </p>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-308">
                The Transdermal Advantage
              </h3>

              <p className="mb-6 font-bold text-gray-900" data-id="element-309">
                But here's the key difference: It's transdermal.
              </p>

              <p className="mb-6" data-id="element-310">
                That means it goes through your skin, not your stomach.
              </p>

              <p className="mb-6" data-id="element-311">Why does that matter?</p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-312">
                Because alcohol damages your gut lining. Even if you're taking
                supplements by mouth, your body can't absorb them properly.
              </p>

              <p className="mb-6" data-id="element-313">
                But transdermal delivery bypasses your digestive system
                entirely. The ingredients go directly into your bloodstream.
                Continuously. For 24 hours.
              </p>

              <p className="mb-8" data-id="element-314">
                No spikes. No crashes. Just steady support.
              </p>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 my-8" data-id="element-315">
                <p className="text-blue-900 font-bold text-lg" data-id="element-316">
                  Over 89% of users report significantly reduced cravings within
                  the first 7 days.
                </p>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-317">
                What Happened to Jennifer, Michael, and Lisa
              </h2>

              <p className="mb-6" data-id="element-318">
                I recommended the Glisera patch to all three of them.
              </p>

              {/* IMAGE 5: Doctor with patient - positive outcome */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-319">
                <img src="https://cdn.magicpatterns.com/uploads/ivE5jD4gCit5MAzygeVjea/ChatGPT_Image_10_Ιαν_2026,_11_55_20_π.μ..png" alt="Doctor having a positive consultation with a patient" className="w-full h-auto rounded-lg" data-id="element-320" />
              </div>

              <div className="space-y-8 mb-8" data-id="element-321">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-322">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-323">
                    Jennifer (The Broken Promise):
                  </h3>
                  <p className="mb-4 text-gray-700" data-id="element-324">
                    Two weeks later, she came back to my office.
                  </p>
                  <p className="mb-4 italic text-gray-700 pl-4 border-l-4 border-[#1E4D3D]" data-id="element-325">
                    "I kept my promise," she said. And then she started crying.
                  </p>
                  <p className="text-gray-700" data-id="element-326">
                    For the first time in four years, she'd made it through a
                    full week without drinking. Not because she used more
                    willpower. But because the 7 PM urge was quieter. Her
                    nervous system finally had the tools to calm down naturally.
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-327">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-328">
                    Michael (The Functional One):
                  </h3>
                  <p className="mb-4 text-gray-700" data-id="element-329">
                    He didn't want to wait until things got worse. He used the
                    patch for three weeks. Then stopped drinking entirely.
                  </p>
                  <p className="italic text-gray-700 pl-4 border-l-4 border-[#1E4D3D]" data-id="element-330">
                    "I didn't know I could feel this calm," he told me. "I
                    thought this was just... how life felt."
                  </p>
                  <p className="mt-4 text-gray-700" data-id="element-331">
                    His cortisol regulated. His GABA rebuilt. And he realized
                    he'd been living in low-level emergency mode for years.
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-332">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-333">
                    Lisa (Wine Stopped Working):
                  </h3>
                  <p className="mb-4 text-gray-700" data-id="element-334">
                    After a month on the patch, she told me something I'll never
                    forget:
                  </p>
                  <p className="italic text-gray-700 pl-4 border-l-4 border-[#1E4D3D]" data-id="element-335">
                    "I feel relaxed for the first time in six years. Not
                    wine-relaxed. Actually relaxed."
                  </p>
                  <p className="mt-4 text-gray-700" data-id="element-336">
                    Her nervous system reset. The cortisol came down. And she
                    didn't need wine to force her body to calm down anymore.
                  </p>
                </div>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-337">
                This Isn't Just My Patients
              </h2>

              <p className="mb-6" data-id="element-338">
                Over 10,000 people have used this method. And the results are
                consistent.
              </p>

              <TestimonialBox testimonials={testimonials} data-id="element-339" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-340">
                Common Questions I Get as a Doctor
              </h2>

              <div className="bg-gray-50 p-8 rounded-lg my-8" data-id="element-341">
                <div className="space-y-6" data-id="element-342">
                  <div data-id="element-343">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-344">
                      "Will people know I'm wearing it?"
                    </h4>
                    <p className="text-gray-700" data-id="element-345">
                      No. The patch is small, thin, and flesh-toned. You wear it
                      on your upper arm or shoulder blade, completely hidden
                      under clothing. It stays on through showers, workouts, and
                      sleep.
                    </p>
                  </div>

                  <div data-id="element-346">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-347">
                      "What if I'm not ready to quit completely?"
                    </h4>
                    <p className="text-gray-700" data-id="element-348">
                      You don't have to. Many of my patients find they can
                      moderate once their nervous system is supported. Others
                      discover they prefer life without alcohol. Either way,
                      you're in control.
                    </p>
                  </div>

                  <div data-id="element-349">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-350">
                      "I'm scared to hope again..."
                    </h4>
                    <p className="text-gray-700" data-id="element-351">
                      I understand. After every failed attempt, hope feels
                      dangerous.
                    </p>
                    <p className="text-gray-700 mt-2 font-bold" data-id="element-352">
                      But here's what I tell my patients: You didn't fail
                      because you're weak. You failed because you were trying to
                      solve a biological problem with behavioral solutions.
                    </p>
                    <p className="text-gray-700 mt-2" data-id="element-353">
                      This is different. And it comes with a 60-day money-back
                      guarantee. If it doesn't work, you get every penny back.
                      No questions asked.
                    </p>
                  </div>
                </div>
              </div>

              <CTASection variant="primary" data-id="element-354" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-16 mb-6 font-sans" data-id="element-355">
                One Last Thing
              </h2>

              <p className="mb-6" data-id="element-356">
                Jennifer sent me a message six months after she started using
                the patch.
              </p>

              {/* IMAGE 6: Woman looking happy and free */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-357">
                <img src="https://cdn.magicpatterns.com/uploads/eXDuJs7i6veAqvzjTp6k1m/ChatGPT_Image_10_Ιαν_2026,_11_55_28_π.μ..png" alt="Woman looking happy, calm and free" className="w-full h-auto rounded-lg" data-id="element-358" />
              </div>

              <p className="mb-6 italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D] text-lg" data-id="element-359">
                "I kept a promise to myself today. That might not sound like
                much. But it's everything."
              </p>

              <p className="mb-6" data-id="element-360">You deserve to trust yourself again.</p>
              <p className="mb-6" data-id="element-361">
                You deserve to feel calm without needing wine to get there.
              </p>
              <p className="mb-6" data-id="element-362">
                You deserve to stop questioning whether this is a problem.
              </p>

              <p className="mb-8 font-bold text-gray-900 text-xl" data-id="element-363">
                Your nervous system needs support. Not judgment. Not pressure.
                Not one more broken promise.
              </p>

              <CTASection variant="final" data-id="element-364" />

              {/* Disclaimer */}
              <div className="mt-12 pt-8 border-t border-gray-200" data-id="element-365">
                <p className="text-xs text-gray-500 leading-relaxed" data-id="element-366">
                  <strong data-id="element-367">DISCLAIMER:</strong> This is an advertorial. The story
                  above is based on clinical experience. Results may vary. This
                  product is not intended to diagnose, treat, cure, or prevent
                  any disease. Statements have not been evaluated by the FDA. If
                  you are experiencing alcohol dependency or withdrawal
                  symptoms, consult a healthcare provider. Alcohol withdrawal
                  can be medically dangerous and may require professional
                  supervision.
                </p>
              </div>
            </div>
          </article>

          {/* Sidebar Column */}
          <aside className="hidden lg:block w-[35%]" data-id="element-368">
            <ProductSidebar data-id="element-369" />
          </aside>
        </div>
      </main>

      <StickyBottomBar data-id="element-370" />
    </div>;
}